/**
 * Modal组件的状态控制
 */
export default module = {
    state: {
        modals: [],
        messageTip: null, //{invalid是否显示红色字体，message展示的信息，target目标elem，customStyle自定义样式}
    },
    mutations: {
        hideModal(state, modalType) {
            let modalIndex = 0;

            modalType && state.modals.some(function(modal, idx) {
                if (modal.type == modalType) {
                    modalIndex = idx;
                    return true;
                }
            });

            state.modals.splice(modalIndex);
        },
        showModal(state, componentData) {
            let modalType = componentData.type;

            let hasModal = state.modals.some(function(modal) {
                if (modal.type == modalType) {
                    return true;
                }
            });

            hasModal || state.modals.push(componentData);
        },
        showMessageTip(state, messageTipData) {
            state.messageTip = messageTipData;
        },
        hideMessageTip(state) {
            state.messageTip = null;
        }
    },
    actions: {
        hideModal(context, modalType) {
            context.commit('hideModal', modalType);
        },
        showModal(context, componentData) {
            context.commit('showModal', componentData);
        },
        showMessageTip(context, messageTipData) {
            context.commit('showMessageTip', messageTipData);
        },
        hideMessageTip(context) {
            context.commit('hideMessageTip');
        },
    }
}